// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-add-campaign-bar {
  position: absolute;
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0px 9px 25px 0px rgba(129, 155, 163, 0.27), 0px 0px 4px 0px rgba(136, 171, 180, 0.39);
  padding: 12px 20px;
  z-index: 1000;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  pointer-events: auto;
  cursor: pointer;
}
.floating-add-campaign-bar .floating-bar-content {
  display: flex;
  align-items: center;
  gap: 12px;
}
.floating-add-campaign-bar .floating-bar-text {
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #40A0C1;
  white-space: nowrap;
}
.floating-add-campaign-bar .floating-bar-button {
  background: #40A0C1;
  color: #FFFFFF;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.floating-add-campaign-bar .floating-bar-button:hover {
  background: #3590b1;
  transform: translateY(-1px);
  box-shadow: 0px 4px 8px rgba(64, 160, 193, 0.3);
}
.floating-add-campaign-bar .floating-bar-button:active {
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/pages/Mapping/FloatingAddToCampaignBar.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iGAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;AACD;AACC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AACF;AAEC;EACC,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAAF;AAGC;EACC,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AADF;AAGE;EACC,mBAAA;EACA,2BAAA;EACA,+CAAA;AADH;AAIE;EACC,wBAAA;AAFH","sourcesContent":[".floating-add-campaign-bar {\n\tposition: absolute;\n\tbackground: #FFFFFF;\n\tborder-radius: 10px;\n\tbox-shadow: 0px 9px 25px 0px rgba(129, 155, 163, 0.27), 0px 0px 4px 0px rgba(136, 171, 180, 0.39);\n\tpadding: 12px 20px;\n\tz-index: 1000;\n\tdisplay: flex;\n\talign-items: center;\n\ttransition: all 0.3s ease;\n\tpointer-events: auto;\n\tcursor: pointer;\n\n\t.floating-bar-content {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 12px;\n\t}\n\n\t.floating-bar-text {\n\t\tfont-family: Inter, sans-serif;\n\t\tfont-weight: 700;\n\t\tfont-size: 14px;\n\t\tcolor: #40A0C1;\n\t\twhite-space: nowrap;\n\t}\n\n\t.floating-bar-button {\n\t\tbackground: #40A0C1;\n\t\tcolor: #FFFFFF;\n\t\tborder: none;\n\t\tborder-radius: 6px;\n\t\tpadding: 8px 16px;\n\t\tfont-family: Inter, sans-serif;\n\t\tfont-weight: 600;\n\t\tfont-size: 14px;\n\t\tcursor: pointer;\n\t\ttransition: all 0.2s ease;\n\t\twhite-space: nowrap;\n\n\t\t&:hover {\n\t\t\tbackground: #3590b1;\n\t\t\ttransform: translateY(-1px);\n\t\t\tbox-shadow: 0px 4px 8px rgba(64, 160, 193, 0.3);\n\t\t}\n\n\t\t&:active {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
